import { MessageCategoryModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export class MessageCenterCategory extends DomainEntity<MessageCategoryModelDto> {
    public createDefault() {
        return new MessageCenterCategory({} as MessageCategoryModelDto) as this;
    }

    public get fiMessageCategoryId() {
        return this.dto.fiMessageCategoryId;
    }

    public get messageCategory() {
        return this.dto.messageCategory;
    }

    public get messageCategoryDescription() {
        return this.dto.categoryDescription;
    }
}
